import MDBadge from "../../../../components/MDBadge";
import {instanceColumns, userListColumns} from "../../../../components/Utils/HeaderColumns";
import {useEffect, useState} from "react";
import GHIconButton from "../../../../components/GHIconButton";
import UserService from "../../../../services/user.service";
import Checkbox from "@mui/material/Checkbox";



function DataTableDataStaffs(progressChanger,clickItem, bulkEmail){
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState(userListColumns);
    useEffect(() => {
    progressChanger(true);

    UserService.getStaffs()
      .then((res) => {
        progressChanger(false);

        if (Array.isArray(res.data)) {
          setRows(res.data);
        } else if (Array.isArray(res.data?.data)) {
          setRows(res.data.data);
        } else {
          setRows([]);
        }

        console.log(res.data);
      })
      .catch((error) => {
        progressChanger(false);
        console.log(error);
        setRows([]); 
      });

  }, []);
    const selectColumn = {
      Header: "",
      accessor: "select",
      width: "5%",
      align: "center",
    };

    return {
        "columns": bulkEmail ? [selectColumn, ...columns] : columns,
        "rows": (rows || []).map(function(element) {
            return {
                    select: bulkEmail ? (
                        <Checkbox
                            checked={Boolean(bulkEmail.selectedRecipients[element.id])}
                            onChange={() =>
                                bulkEmail.onToggleRecipient({
                                    id: element.id,
                                    email: element.email || "",
                                    name: `${element.first_name || ""} ${element.last_name || ""}`.trim(),
                                })
                            }
                        />
                    ) : null,
                    // user: <CustomerCell image={CoreService.BASE_API_URL + element.avatar}
                    //                     color={element.color || "dark"}
                    //                     name={element.first_name + " " + element.last_name}
                    //                     email={element.email} />,
                    name: element.first_name + " " + element.last_name,
                    email: element.email,
                    status: (element.status === "active" ?
                                    <MDBadge badgeContent="active" color="success" size="sm" container /> :
                                    <MDBadge badgeContent={element.status} color="error" size="sm" container />),
                    lastLogin : element.last_login,
                    role: element.role,
                    client : element.client,
                    building : element.client,
                    unit : element.unit,
                    instance : element.instance,
                    actions: (
                        <div>
                          {/*<GHIconButton onClick={clickItem} id={element.id} action={"book_amenity"}     client={element.client}*/}
                          {/*              rowName={element.email} title={"Book Amenity"} color={"primary"} icon={"event"} size={"medium"}  />*/}
                          {/*<GHIconButton onClick={clickItem} id={element.id} action={"resend_confirm"}   client={element.client}*/}
                          {/*              rowName={element.email} title={"Resend Confirm"} color={"info"} icon={"email"} size={"medium"}  />*/}
                          <GHIconButton onClick={clickItem} id={element.id} action={"change_password"}  client={element.client}
                                        rowName={element.email} title={"Change Password"} color={"secondary"} icon={"password"} size={"medium"} />
                          <GHIconButton onClick={clickItem} id={element.id} action={"edit"}             client={element.client}
                                        rowName={element.email} title={"Edit"} color={"warning"} icon={"edit"} size={"medium"} />
                          <GHIconButton onClick={clickItem}  id={element.id} action={"delete"}          client={element.client}
                                        rowName={element.email} title={"Delete"} color={"error"} icon={"delete"} size={"medium"} />
                          <GHIconButton onClick={clickItem}  id={element.id} action={"disable"}         client={element.client}
                                        rowName={element.name}
                                        title={element.status === "active"? "Disable" : "Active"}
                                        color={element.status === "active"? "info" : "error"}
                                        icon={element.status === "active"? "toggle_off" : "toggle_on"}
                                        size={"medium"} />
                        </div>
                    ),
            }
        }),
    }
}

export default DataTableDataStaffs;
